import React from 'react';
import classNames from 'classnames';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Picture } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import quoteIcon from '../../../../public/icons/quote_icon.svg';

import './Quote.module.css';
import { withTranslation } from 'react-i18next';

const Quote = ({ quote, name, title, t, alignment }) => {
  const size = quote.length > 200 ? 'long' : 'short';

  return (
    <div styleName={classNames('quote', alignment)}>
      <Grid direction="x" primaryAlignment="align-center">
        <Cell smallSize={16} mediumSize={18}>
          <div styleName="slide-alignment">
            <Picture largeImage={quoteIcon} width="32" alt="" />
            <p styleName={size}>{quote}</p>
            <p styleName="author">
              {name} {title}
            </p>
          </div>
        </Cell>
      </Grid>
    </div>
  );
};

export default DisplayComponent(withTranslation()(Quote));
